<template>
    <page title="Introduction">
        <section>
            <p>
                This site shows the full documentation for our HTTP API. It is split into sections according to API
                resources, each of them listing all of their endpoints.<br>
                The documentation is designed to be an interactive web application: You may execute all HTTP calls it
                describes, simply by filling in the parameters (if any) and hitting <em>Submit</em>.

            </p>
            <blockquote>
                <p>
                    Please note that this document is automatically generated: It usually reflects the exact state of
                    the API.
                </p>
            </blockquote>
        </section>
        <section>
            <header>
                <h2>Current System Status</h2>
            </header>
            <p>
                You may view the current status of our API and all related sub-systems on our
                <a href="https://status.messengerpeople.com/" target="_blank" rel="noopener">Status Page</a>.
            </p>
        </section>
        <section>
            <header>
                <h2>Data types</h2>
            </header>
            <p>
                We exclusively use <a href="https://json.org/" target="_blank" rel="noopener">JSON</a> as the data type
                for all our endpoints, except those that allow uploading arbitrary media files: These endpoints expect
                the MIME type of the media file to be sent in the <code>Content-Type</code> header.<br>
                You can find a detailed list of all field types used on the
                <router-link :to="ROUTE_TYPES">Types page.</router-link>
            </p>
        </section>
        <section>
            <header>
                <h2>SDKs and packages for your programming language</h2>
            </header>
            <p>
                We provide a range of API clients for different programming languages on GitHub and the languages
                package repositories, if available.<br>
                Please take a look at our <a href="https://github.com/messengerpeople/" target="_blank" rel="noopener">repositories</a>
                to get started quickly.
            </p>
        </section>
        <section>
            <header>
                <h2>Authentication and Authorization</h2>
            </header>
            <p>
                We use OAuth 2.0 for authorization and act as an identity provider. You can read more in the
                authentication page.
            </p>
        </section>
    </page>
</template>

<script>
  import { ROUTE_TYPES } from '../../router';
  import Page            from '../Layout/Page';
  import MarkdownText    from '../MarkdownText';

  export default {
    name: 'OverView',

    components: {
      MarkdownText,
      Page,
    },

    data () {
      return {
        ROUTE_TYPES,
      };
    },
  };
</script>

<style scoped>
    h1 {
        margin:         1.25rem 0 2rem;
        padding-bottom: 2rem;
        border-bottom:  1px solid var(--color-gray-lighter);
        line-height:    1;
        font-size:      2.2rem;
        color:          var(--color-primary-shade);
    }

    h2 {
        margin: 2rem 0 0.5rem;
        color:  var(--color-primary);
    }

    h3 {
        margin: 2rem 0 0.5rem;
        color:  var(--color-primary);
    }

    a {
        text-decoration: none;
        padding:         2px 0;
        color:           inherit;
        box-shadow:      0 3px 0 0 var(--color-gray-lighter);
        transition:      all 0.125s;
    }

    a:hover {
        color:      var(--color-primary);
        box-shadow: 0 3px 0 0 var(--color-primary-highlight);
    }

    p {
        line-height: 1.6;
        font-size:   1.15rem;
        font-weight: normal;
        margin:      0.75rem 0 0.25rem 0;
    }

    p code {
        font-size:     1.1rem;
        padding:       4px 6px;
        border-radius: 4px;
        background:    linear-gradient(120deg, rgba(0, 0, 0, 0.05), rgba(10, 64, 30, 0.1));
    }


    blockquote {
        position:      relative;
        margin:        0.5rem 0;
        padding:       0.5rem 1rem 0.5rem 2rem;
        border-left:   1.4rem solid var(--color-primary-highlight);
        border-radius: 0 5px 5px 0;
        background:    var(--color-primary-faded);
    }

    blockquote::before {
        position:    absolute;
        left:        -1.2rem;
        top:         1rem;
        content:     '\e88e';
        font-family: 'Material Icons';
        font-size:   1rem;
        color:       rgba(0, 0, 0, 0.25);
    }

    blockquote p {
        margin:      0;
        color:       rgba(0, 0, 0, 0.6);
        text-shadow: 1px 1px rgba(255, 255, 255, 0.5);
    }
</style>
